var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59 0h27.82C30.288 0 31 .716 31 1.6v16.8c0 .884-.712 1.6-1.59 1.6H1.59C.712 20 0 19.284 0 18.4V1.6C0 .716.712 0 1.59 0z",
    fill: "#0E4595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.653 13.95 1.326-7.831h2.12l-1.326 7.83h-2.12zm9.781-7.662a5.446 5.446 0 0 0-1.9-.33c-2.096 0-3.572 1.063-3.585 2.585-.011 1.125 1.054 1.753 1.859 2.127.825.384 1.102.629 1.099.972-.006.524-.66.764-1.27.764-.848 0-1.299-.118-1.995-.41l-.274-.125-.297 1.753c.495.218 1.411.408 2.362.417 2.23 0 3.676-1.05 3.693-2.675.008-.89-.557-1.568-1.78-2.127-.742-.363-1.196-.604-1.191-.971 0-.326.384-.674 1.214-.674a3.892 3.892 0 0 1 1.588.3l.19.09.287-1.696m5.457-.17h-1.638c-.508 0-.888.14-1.11.65l-3.15 7.176h2.227s.364-.965.446-1.177l2.716.004c.063.274.258 1.173.258 1.173h1.968L26.89 6.118zm-2.6 5.057c.176-.451.845-2.189.845-2.189-.012.021.174-.453.281-.747l.144.675.49 2.261h-1.76zM9.853 6.12l-2.077 5.34-.22-1.086c-.387-1.25-1.592-2.606-2.938-3.284l1.898 6.848 2.244-.003L12.1 6.12H9.853",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84 6.118H2.42l-.028.163c2.66.648 4.421 2.215 5.152 4.097L6.8 6.779c-.128-.495-.5-.643-.96-.66",
    fill: "#F2AE14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaSvgrepoCom);
export default __webpack_public_path__ + "static/media/visa-svgrepo-com.93069ce52b253b3d57422367ad17f137.svg";
export { ForwardRef as ReactComponent };